import styled, { css } from 'styled-components'

import { Option } from 'components/Option'

import { Color } from 'root-constants'

type TOptionWrapperProps = {
  $imageUrl: string
  checked?: boolean
  $minHeight?: string
  $backgroundColor?: string
  $renderImageAsImg?: boolean
}

export const StyledOptionCard = {
  Option: styled(Option)<TOptionWrapperProps>`
    position: relative;
    width: 100%;
    height: 100%;

    aspect-ratio: 375 / 256;
    min-height: ${({ $minHeight }) => $minHeight || '235px'};
    border-radius: 16px;
    background-color: ${({ $backgroundColor }) =>
      $backgroundColor || Color.WHITE};
    background-image: ${({ $imageUrl, $renderImageAsImg }) =>
      $renderImageAsImg ? 'none' : `url(${$imageUrl})`};
    background-position: center top;
    background-size: cover;
    background-repeat: no-repeat;
    overflow: hidden;
    cursor: pointer;
    outline: none;
    transition: all 200ms ease-out;

    &::after {
      content: '';
      position: absolute;
      inset: 0;
      border-radius: inherit;
      background-color: ${({ checked }) =>
        checked ? 'rgba(255, 255, 255, 0.1)' : 'transparent'};
      transition: background-color 200ms ease-out;
      z-index: 1;
    }

    ${({ checked }) =>
      checked &&
      css`
        box-shadow:
          0 0 0 2px ${Color.WHITE},
          0 4px 12px rgba(255, 255, 255, 0.2);
      `}

    &:disabled {
      cursor: not-allowed;
      opacity: 0.6;
    }

    &:hover:not(:disabled) {
      transform: scale(1.02);
    }
  `,
  Image: styled.img`
    position: absolute;
    inset: 0;
    z-index: 0;

    width: 100%;
    height: 100%;

    object-fit: cover;
    object-position: center top;
  `,
  OptionLabel: styled.div<{ $isCompact?: boolean }>`
    position: absolute;
    bottom: 12px;
    left: 12px;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${({ $isCompact }) => ($isCompact ? '4px' : '8px')};
    width: calc(100% - 24px);
    min-height: 48px;
    padding: ${({ $isCompact }) => ($isCompact ? '8px 10px' : '12px 16px')};
    border-radius: 48px;
    background-color: rgba(255, 255, 255, 0.9);

    font-size: ${({ $isCompact }) =>
      $isCompact ? 'clamp(12px, 3.6vw, 14px)' : '16px'};
    font-weight: 500;
    line-height: ${({ $isCompact }) => ($isCompact ? '16px' : '20px')};
    white-space: ${({ $isCompact }) => ($isCompact ? 'normal' : 'nowrap')};

    svg {
      flex-shrink: 0;

      :dir(rtl) {
        transform: scaleX(-1);
      }
    }
  `,
}
